module.exports = __webpack_public_path__ + "assets/img/modelo_stories_com_logo.509fad86.png";